import React from "react";
import { CircularProgress } from "@mui/material";

export function Arrow(props: IconProps) {
  return (
    <svg
      width="8"
      height="15"
      viewBox="0 0 8 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.38825 13.7567L6.62581 7.41513L1.00115 1.39764"
        stroke={props.color || "white"}
        strokeWidth="2"
      />
    </svg>
  );
}

export function AllDocs(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill={props.color}
    >
      <path d="M480-424.62 80.77-632.31 480-840l400 207.69-400 207.69Zm0 152.31L103.77-467.77l41.69-22.92L480-317.92l335.31-172.77L857-467.77 480-272.31ZM480-120 103.77-315.46l41.69-22.92L480-165.62l335.31-172.76L857-315.46 480-120Zm0-350.23 316.85-162.08L480-794.38 163.92-632.31 480-470.23Zm.77-162.08Z" />
    </svg>
  );
}

export function External(props: IconProps) {
  return (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.84839 6.07432C3.84839 3.60587 3.84839 2.37165 4.61524 1.6048C5.38208 0.837952 6.6163 0.837952 9.08475 0.837952H10.8302C13.2986 0.837952 14.5328 0.837952 15.2997 1.6048C16.0666 2.37165 16.0666 3.60587 16.0666 6.07432V13.0561C16.0666 15.5246 16.0666 16.7588 15.2997 17.5256C14.5328 18.2925 13.2986 18.2925 10.8302 18.2925H9.08475C6.6163 18.2925 5.38208 18.2925 4.61524 17.5256C3.84839 16.7588 3.84839 15.5246 3.84839 13.0561V6.07432Z"
        stroke={props.color}
      />
      <path
        d="M3.84835 2.6499C2.99736 2.73361 2.42455 2.92279 1.99701 3.35032C1.23016 4.11717 1.23016 5.3514 1.23016 7.81988V11.3108C1.23016 13.7792 1.23016 15.0134 1.99701 15.7803C2.42455 16.2078 2.99736 16.397 3.84835 16.4807"
        stroke={props.color}
      />
      <path
        d="M16.0665 2.6499C16.9175 2.73361 17.4903 2.92279 17.9178 3.35032C18.6847 4.11717 18.6847 5.3514 18.6847 7.81988V11.3108C18.6847 13.7792 18.6847 15.0134 17.9178 15.7803C17.4903 16.2078 16.9175 16.397 16.0665 16.4807"
        stroke={props.color}
      />
      <path
        d="M7.33923 10.4379H12.5756"
        stroke={props.color}
        strokeLinecap="round"
      />
      <path
        d="M7.33923 6.94705H12.5756"
        stroke={props.color}
        strokeLinecap="round"
      />
      <path
        d="M7.33923 13.9289H9.95742"
        stroke={props.color}
        strokeLinecap="round"
      />
    </svg>
  );
}

export function Support(props: IconProps) {
  return (
    <svg
      width={props.width || "24px"}
      height={props.height || "25px"}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="25" fill="#1E1E1E" />
      <g clipPath="url(#clip0_6_2)">
        <rect
          width="1920"
          height="1080"
          transform="translate(-1629 -22)"
          fill="white"
        />
        <rect x="-1629" y="-22" width="1920" height="1080" fill="#F7F8FA" />
        <mask id="path-2-inside-1_6_2" fill="white">
          <path d="M21.4419 21.0522C22.7146 19.6204 23.4305 17.6584 23.2979 15.5372C23.1123 12.9388 21.548 10.6851 19.3473 9.51852C19.3473 9.73064 19.3473 9.94275 19.3473 10.1814C19.1352 15.1925 15.0255 19.4348 9.98783 19.8325C9.80223 19.8325 9.61663 19.859 9.43103 19.859C10.6507 21.9006 12.7983 23.3324 15.2641 23.518C16.2982 23.571 17.3057 23.4649 18.2602 23.1468C18.7375 22.9877 20.62 23.8892 21.6805 24.446C21.9457 24.5785 22.2639 24.3134 22.1313 24.0217C21.7336 23.0142 21.2033 21.3438 21.4419 21.0522Z" />
        </mask>
        <path
          d="M21.4419 21.0522C22.7146 19.6204 23.4305 17.6584 23.2979 15.5372C23.1123 12.9388 21.548 10.6851 19.3473 9.51852C19.3473 9.73064 19.3473 9.94275 19.3473 10.1814C19.1352 15.1925 15.0255 19.4348 9.98783 19.8325C9.80223 19.8325 9.61663 19.859 9.43103 19.859C10.6507 21.9006 12.7983 23.3324 15.2641 23.518C16.2982 23.571 17.3057 23.4649 18.2602 23.1468C18.7375 22.9877 20.62 23.8892 21.6805 24.446C21.9457 24.5785 22.2639 24.3134 22.1313 24.0217C21.7336 23.0142 21.2033 21.3438 21.4419 21.0522Z"
          stroke="#1860D9"
          strokeWidth="2"
          mask="url(#path-2-inside-1_6_2)"
        />
        <mask id="path-3-inside-2_6_2" fill="white">
          <path d="M18.3398 10.1283C18.1277 14.6888 14.4422 18.4803 9.90828 18.825C8.6356 18.9045 7.38944 18.7454 6.22282 18.3742C5.61299 18.1621 3.33278 19.3022 2.00707 19.9916C1.6889 20.1507 1.29119 19.8325 1.45028 19.4613C1.92753 18.1886 2.6169 16.1205 2.29873 15.7759C0.734397 13.9994 -0.140569 11.6131 0.0185159 8.98824C0.336685 4.42781 4.15472 0.715837 8.71514 0.530238C14.124 0.265097 18.5784 4.71947 18.3398 10.1283Z" />
        </mask>
        <path
          d="M18.3398 10.1283C18.1277 14.6888 14.4422 18.4803 9.90828 18.825C8.6356 18.9045 7.38944 18.7454 6.22282 18.3742C5.61299 18.1621 3.33278 19.3022 2.00707 19.9916C1.6889 20.1507 1.29119 19.8325 1.45028 19.4613C1.92753 18.1886 2.6169 16.1205 2.29873 15.7759C0.734397 13.9994 -0.140569 11.6131 0.0185159 8.98824C0.336685 4.42781 4.15472 0.715837 8.71514 0.530238C14.124 0.265097 18.5784 4.71947 18.3398 10.1283Z"
          stroke="#1860D9"
          strokeWidth="2"
          mask="url(#path-3-inside-2_6_2)"
        />
        <mask id="path-4-inside-3_6_2" fill="white">
          <path d="M9.37797 11.7987H8.66209C8.44998 11.7987 8.26438 11.6131 8.26438 11.401C8.26438 10.9237 8.34392 10.526 8.503 10.2079C8.66209 9.88969 8.98026 9.545 9.45751 9.17381C9.93477 8.77609 10.2264 8.53747 10.306 8.4049C10.4385 8.2193 10.5181 8.00718 10.5181 7.76856C10.5181 7.45039 10.3855 7.18525 10.1469 6.94662C9.88174 6.70799 9.56357 6.60194 9.11283 6.60194C8.6886 6.60194 8.34392 6.70799 8.07878 6.94662C7.91969 7.07919 7.78712 7.26479 7.68107 7.4769C7.5485 7.79507 7.23033 7.98067 6.88564 7.95416C6.35536 7.87461 6.03719 7.2913 6.30233 6.81405C6.4349 6.54891 6.64702 6.31028 6.88564 6.07166C7.44244 5.5944 8.15832 5.35577 9.03329 5.35577C9.96128 5.35577 10.7037 5.5944 11.2605 6.09817C11.8173 6.57542 12.0824 7.15873 12.0824 7.79507C12.0824 8.16627 11.9764 8.48444 11.7908 8.80261C11.6052 9.12078 11.1544 9.57152 10.4916 10.1018C10.1469 10.3935 9.93477 10.6056 9.85522 10.7912C9.8022 10.9237 9.74917 11.1093 9.74917 11.3745C9.74917 11.6396 9.59008 11.7987 9.37797 11.7987ZM8.29089 13.2039V13.1244C8.29089 12.7002 8.63557 12.3555 9.0598 12.3555H9.13934C9.56357 12.3555 9.90825 12.7002 9.90825 13.1244V13.2039C9.90825 13.6282 9.56357 13.9729 9.13934 13.9729H9.0598C8.63557 13.9729 8.29089 13.6282 8.29089 13.2039Z" />
        </mask>
        <path
          d="M9.37797 11.7987H8.66209C8.44998 11.7987 8.26438 11.6131 8.26438 11.401C8.26438 10.9237 8.34392 10.526 8.503 10.2079C8.66209 9.88969 8.98026 9.545 9.45751 9.17381C9.93477 8.77609 10.2264 8.53747 10.306 8.4049C10.4385 8.2193 10.5181 8.00718 10.5181 7.76856C10.5181 7.45039 10.3855 7.18525 10.1469 6.94662C9.88174 6.70799 9.56357 6.60194 9.11283 6.60194C8.6886 6.60194 8.34392 6.70799 8.07878 6.94662C7.91969 7.07919 7.78712 7.26479 7.68107 7.4769C7.5485 7.79507 7.23033 7.98067 6.88564 7.95416C6.35536 7.87461 6.03719 7.2913 6.30233 6.81405C6.4349 6.54891 6.64702 6.31028 6.88564 6.07166C7.44244 5.5944 8.15832 5.35577 9.03329 5.35577C9.96128 5.35577 10.7037 5.5944 11.2605 6.09817C11.8173 6.57542 12.0824 7.15873 12.0824 7.79507C12.0824 8.16627 11.9764 8.48444 11.7908 8.80261C11.6052 9.12078 11.1544 9.57152 10.4916 10.1018C10.1469 10.3935 9.93477 10.6056 9.85522 10.7912C9.8022 10.9237 9.74917 11.1093 9.74917 11.3745C9.74917 11.6396 9.59008 11.7987 9.37797 11.7987ZM8.29089 13.2039V13.1244C8.29089 12.7002 8.63557 12.3555 9.0598 12.3555H9.13934C9.56357 12.3555 9.90825 12.7002 9.90825 13.1244V13.2039C9.90825 13.6282 9.56357 13.9729 9.13934 13.9729H9.0598C8.63557 13.9729 8.29089 13.6282 8.29089 13.2039Z"
          fill="#1860D9"
          stroke="#1860D9"
          strokeWidth="13.3333"
          mask="url(#path-4-inside-3_6_2)"
        />
      </g>
      <defs>
        <clipPath id="clip0_6_2">
          <rect
            width="1920"
            height="1080"
            fill={props.color}
            transform="translate(-1629 -22)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function Internal(props: IconProps) {
  return (
    <svg
      width="22"
      height="19"
      viewBox="0 0 22 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.25 5.97223H19.75M2.25 5.97223V15.9693C2.25 17.35 3.36929 18.4693 4.75 18.4693H17.25C18.6307 18.4693 19.75 17.35 19.75 15.9693V5.97223M2.25 5.97223C1.55964 5.97223 1 5.41258 1 4.72223V2.25C1 1.55964 1.55964 1 2.25 1H19.75C20.4404 1 21 1.55964 21 2.25V4.72223C21 5.41258 20.4404 5.97223 19.75 5.97223"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 9.72226H13.5"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function Settings(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_65_149"
        // style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_65_149)">
        <path
          d="M12.029 14.0992C13.6297 14.0992 14.9273 12.8634 14.9273 11.3389C14.9273 9.81443 13.6297 8.5786 12.029 8.5786C10.4283 8.5786 9.13068 9.81443 9.13068 11.3389C9.13068 12.8634 10.4283 14.0992 12.029 14.0992Z"
          stroke={props.color}
        />
        <path
          d="M13.7088 2.09884C13.359 1.95386 12.9157 1.95386 12.029 1.95386C11.1423 1.95386 10.699 1.95386 10.3492 2.09884C9.88294 2.29215 9.51247 2.66293 9.31933 3.1296C9.23116 3.34265 9.19665 3.5904 9.18315 3.95179C9.16331 4.48288 8.89118 4.97447 8.43129 5.2402C7.97143 5.50592 7.40999 5.496 6.94052 5.24766C6.62106 5.07866 6.38943 4.98469 6.161 4.9546C5.6606 4.88866 5.15453 5.02437 4.75412 5.33188C4.45381 5.56251 4.23213 5.94679 3.78879 6.71533C3.34544 7.48388 3.12377 7.86814 3.07436 8.24376C3.00849 8.74457 3.14409 9.25106 3.45134 9.65183C3.59157 9.83477 3.78866 9.98847 4.09456 10.1808C4.54426 10.4637 4.8336 10.9454 4.83357 11.4769C4.83354 12.0084 4.54421 12.4901 4.09456 12.7728C3.78862 12.9653 3.59149 13.1191 3.45124 13.302C3.14399 13.7028 3.00839 14.2092 3.07427 14.71C3.12368 15.0856 3.34535 15.47 3.78869 16.2385C4.23205 17.007 4.45372 17.3913 4.75403 17.6219C5.15444 17.9294 5.66051 18.0651 6.1609 17.9992C6.38931 17.9691 6.62094 17.8751 6.94038 17.7062C7.40988 17.4578 7.97136 17.4479 8.43126 17.7136C8.89116 17.9794 9.16331 18.471 9.18315 19.0022C9.19666 19.3635 9.23116 19.6113 9.31933 19.8243C9.51247 20.2909 9.88294 20.6617 10.3492 20.8551C10.699 21 11.1423 21 12.029 21C12.9157 21 13.359 21 13.7088 20.8551C14.175 20.6617 14.5455 20.2909 14.7386 19.8243C14.8268 19.6113 14.8613 19.3635 14.8749 19.0021C14.8947 18.471 15.1668 17.9794 15.6266 17.7136C16.0865 17.4478 16.648 17.4578 17.1176 17.7062C17.437 17.8751 17.6686 17.969 17.8969 17.9991C18.3973 18.0651 18.9034 17.9294 19.3038 17.6219C19.6041 17.3912 19.8258 17.007 20.2691 16.2384C20.7125 15.4699 20.9342 15.0856 20.9836 14.71C21.0495 14.2092 20.9139 13.7027 20.6066 13.3019C20.4664 13.119 20.2692 12.9652 19.9633 12.7728C19.5137 12.4901 19.2244 12.0083 19.2244 11.4768C19.2244 10.9454 19.5137 10.4638 19.9633 10.181C20.2693 9.98857 20.4665 9.83487 20.6067 9.65183C20.914 9.25113 21.0496 8.74464 20.9837 8.24382C20.9343 7.86821 20.7126 7.48393 20.2692 6.71539C19.8259 5.94685 19.6042 5.56258 19.3039 5.33195C18.9035 5.02444 18.3974 4.88873 17.897 4.95466C17.6687 4.98476 17.4371 5.07872 17.1176 5.2477C16.6481 5.49605 16.0866 5.50598 15.6267 5.24023C15.1668 4.97449 14.8947 4.48286 14.8749 3.95174C14.8613 3.59038 14.8268 3.34264 14.7386 3.1296C14.5455 2.66293 14.175 2.29215 13.7088 2.09884Z"
          stroke={props.color}
        />
      </g>
    </svg>
  );
}

export function Outcoming(props: IconProps) {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.2222 16.6285V10.343M14.2222 10.343H7.93682M14.2222 10.343L4.92893 19.6364M10.048 22.3739C13.2115 23.0005 16.6194 22.0879 19.0711 19.6364C22.9763 15.731 22.9763 9.39941 19.0711 5.49415C15.1658 1.5889 8.83417 1.5889 4.92893 5.49415C2.4773 7.94579 1.56476 11.3537 2.19129 14.5172"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function Incoming(props: IconProps) {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.77779 7.93682V14.2222M9.77779 14.2222H15.8889M9.77779 14.2222L19.0711 4.92893M13.952 2.19129C10.7885 1.56476 7.38058 2.4773 4.92894 4.92893C1.02369 8.83417 1.02369 15.1658 4.92894 19.0711C8.83419 22.9763 15.1658 22.9763 19.0711 19.0711C21.5227 16.6194 22.4353 13.2115 21.8087 10.048"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Info(props: IconProps) {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_63_121"
        //  style={{maskType: "alpha"}}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="25"
      >
        <rect y="0.565216" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_63_121)">
        <path
          d="M12.0593 8.04169H11.9459"
          stroke={props.color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.0027 15.9084V12.5084"
          stroke={props.color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.1223 14.0448C3.35545 15.4432 3.91561 16.7668 4.75714 17.9076C5.59867 19.0485 6.69777 19.9744 7.96491 20.61C9.23205 21.2456 10.6314 21.5728 12.0489 21.5651C13.4665 21.5573 14.8622 21.2148 16.1223 20.5654L19.5123 21.2655C19.6743 21.2986 19.842 21.291 20.0003 21.2434C20.1587 21.1958 20.3027 21.1097 20.4197 20.9928C20.5366 20.8759 20.6227 20.7318 20.6703 20.5734C20.7178 20.4151 20.7254 20.2474 20.6923 20.0854L20.0023 16.6851C20.6544 15.418 20.9963 14.0143 21 12.5893C21.0036 11.1643 20.669 9.75874 20.0234 8.48836C19.3779 7.21798 18.44 6.11903 17.2869 5.28193C16.1338 4.44484 14.7984 3.89351 13.3907 3.67332C11.9829 3.45313 10.543 3.57036 9.18938 4.01538C7.83577 4.4604 6.60715 5.22047 5.60461 6.23308C4.60207 7.24569 3.85427 8.48188 3.42271 9.83995C2.99116 11.198 2.8882 12.6392 3.1223 14.0448Z"
          stroke={props.color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}
export function Contact(props: IconProps) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_2608_2660" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill={props.color} />
      </mask>
      <g mask="url(#mask0_2608_2660)">
        <rect x="3.5" y="4.42297" width="17.2686" height="17.2686" rx="3.5" stroke={props.color} />
        <path d="M10.2114 6.8075V1.99996" stroke={props.color} strokeLinecap="round" />
        <path d="M14.0571 6.8075V1.99996" stroke={props.color} strokeLinecap="round" />
        <circle cx="12.1342" cy="14.0189" r="1.90377" stroke={props.color} />
        <path d="M17.8777 21.3738C17.5736 20.6358 17.1271 19.9649 16.5637 19.3995C16.0003 18.8341 15.331 18.3852 14.5941 18.0784C13.8572 17.7716 13.0671 17.613 12.2689 17.6115C11.4707 17.6101 10.6801 17.7659 9.94207 18.0701C9.20408 18.3742 8.53322 18.8207 7.9678 19.3841C7.40238 19.9475 6.95346 20.6168 6.64668 21.3537" stroke={props.color} />
      </g>
    </svg>
  );
}

export function Bookmark(props: IconProps) {
  return (
    <svg
      width="11"
      height="13"
      viewBox="0 0 11 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 13V1.07586C0 0.788966 0.117857 0.537931 0.353571 0.322759C0.589286 0.107586 0.864286 0 1.17857 0H9.82143C10.1357 0 10.4107 0.107586 10.6464 0.322759C10.8821 0.537931 11 0.788966 11 1.07586V13L5.5 10.8483L0 13ZM1.17857 11.3683L5.5 9.70069L9.82143 11.3683V1.07586H1.17857V11.3683ZM1.17857 1.07586H9.82143H5.5H1.17857Z"
        fill={props.color}
      />
    </svg>
  );
}
export function Comment(props: IconProps) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6802 11.8801L9.39223 9.59206H1.09823C0.878968 9.59206 0.681151 9.50388 0.504784 9.32751C0.328418 9.15115 0.240234 8.95333 0.240234 8.73406V1.29806C0.240234 1.0788 0.328418 0.88098 0.504784 0.704614C0.681151 0.528247 0.878968 0.440063 1.09823 0.440063H10.8222C11.051 0.440063 11.2512 0.528247 11.4228 0.704614C11.5944 0.88098 11.6802 1.0788 11.6802 1.29806V11.8801ZM1.09823 1.29806V8.73406H9.74973L10.8222 9.80656V1.29806H1.09823Z"
        fill={props.color}
      />
    </svg>
  );
}
export function Download(props: IconProps) {
  return (
    <svg
      width="15"
      height="12"
      viewBox="0 0 15 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.1447 11.8801V10.7202L4.9202 9.9734H1.95021C1.68621 9.9734 1.45521 9.87806 1.25721 9.6874C1.05921 9.49673 0.960205 9.27429 0.960205 9.02006V1.3934C0.960205 1.13917 1.05921 0.91673 1.25721 0.726063C1.45521 0.535397 1.68621 0.440063 1.95021 0.440063H8.5007V1.3934H1.95021V9.02006H13.1702V6.81151H14.1602V9.02006C14.1602 9.27429 14.0612 9.49673 13.8632 9.6874C13.6652 9.87806 13.4342 9.9734 13.1702 9.9734H10.2002L10.9922 10.7202V11.8801H4.1447ZM9.9857 8.28917L6.80121 5.22262L7.4942 4.55529L9.4907 6.46195V0.440063H10.4807V6.46195L12.4772 4.55529L13.1702 5.22262L9.9857 8.28917Z"
        fill={props.color}
      />
    </svg>
  );
}
export function Link(props: IconProps) {
  return (
    <svg
      width="17"
      height="8"
      viewBox="0 0 17 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.8625 8H4.25C3.07417 8 2.07188 7.61 1.24313 6.83C0.414375 6.05 0 5.10667 0 4C0 2.89333 0.414375 1.95 1.24313 1.17C2.07188 0.39 3.07417 0 4.25 0H7.8625V1.2H4.25C3.42833 1.2 2.72708 1.47333 2.14625 2.02C1.56542 2.56667 1.275 3.22667 1.275 4C1.275 4.77333 1.56542 5.43333 2.14625 5.98C2.72708 6.52667 3.42833 6.8 4.25 6.8H7.8625V8ZM5.20625 4.6V3.4H11.7938V4.6H5.20625ZM9.1375 8V6.8H12.75C13.5717 6.8 14.2729 6.52667 14.8538 5.98C15.4346 5.43333 15.725 4.77333 15.725 4C15.725 3.22667 15.4346 2.56667 14.8538 2.02C14.2729 1.47333 13.5717 1.2 12.75 1.2H9.1375V0H12.75C13.9258 0 14.9281 0.39 15.7569 1.17C16.5856 1.95 17 2.89333 17 4C17 5.10667 16.5856 6.05 15.7569 6.83C14.9281 7.61 13.9258 8 12.75 8H9.1375Z"
        fill={props.color}
      />
    </svg>
  );
}
export function Print(props: IconProps) {
  return (
    <svg
      width="15"
      height="13"
      viewBox="0 0 15 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8375 3.46667V1.08333H4.1625V3.46667H3.0375V0H11.9625V3.46667H10.8375ZM1.125 4.55H13.875H3.0375H1.125ZM12.3563 6.26528C12.5063 6.26528 12.6375 6.21111 12.75 6.10278C12.8625 5.99444 12.9188 5.86806 12.9188 5.72361C12.9188 5.57917 12.8625 5.45278 12.75 5.34444C12.6375 5.23611 12.5063 5.18194 12.3563 5.18194C12.2063 5.18194 12.075 5.23611 11.9625 5.34444C11.85 5.45278 11.7938 5.57917 11.7938 5.72361C11.7938 5.86806 11.85 5.99444 11.9625 6.10278C12.075 6.21111 12.2063 6.26528 12.3563 6.26528ZM10.8375 11.9167V8.45H4.1625V11.9167H10.8375ZM11.9625 13H3.0375V9.82222H0V5.38056C0 4.83889 0.190625 4.38449 0.571875 4.01736C0.953125 3.65023 1.425 3.46667 1.9875 3.46667H13.0125C13.575 3.46667 14.0469 3.65023 14.4281 4.01736C14.8094 4.38449 15 4.83889 15 5.38056V9.82222H11.9625V13ZM13.875 8.73889V5.38056C13.875 5.13981 13.7937 4.9412 13.6312 4.78472C13.4687 4.62824 13.2625 4.55 13.0125 4.55H1.9875C1.7375 4.55 1.53125 4.62824 1.36875 4.78472C1.20625 4.9412 1.125 5.13981 1.125 5.38056V8.73889H3.0375V7.36667H11.9625V8.73889H13.875Z"
        fill={props.color}
      />
    </svg>
  );
}
export function Question(props: IconProps) {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.565 10.2863C6.73833 10.2863 6.88458 10.2267 7.00375 10.1075C7.12292 9.98833 7.1825 9.84208 7.1825 9.66875C7.1825 9.49542 7.12292 9.34917 7.00375 9.23C6.88458 9.11083 6.73833 9.05125 6.565 9.05125C6.39167 9.05125 6.24542 9.11083 6.12625 9.23C6.00708 9.34917 5.9475 9.49542 5.9475 9.66875C5.9475 9.84208 6.00708 9.98833 6.12625 10.1075C6.24542 10.2267 6.39167 10.2863 6.565 10.2863ZM5.99625 7.91375H6.955C6.955 7.63208 6.99021 7.37479 7.06063 7.14187C7.13104 6.90896 7.35042 6.64083 7.71875 6.3375C8.05458 6.05583 8.29292 5.77958 8.43375 5.50875C8.57458 5.23792 8.645 4.94 8.645 4.615C8.645 4.04083 8.45813 3.58042 8.08437 3.23375C7.71062 2.88708 7.215 2.71375 6.5975 2.71375C6.06667 2.71375 5.59812 2.84646 5.19187 3.11187C4.78562 3.37729 4.49042 3.74292 4.30625 4.20875L5.1675 4.53375C5.28667 4.23042 5.46542 3.99479 5.70375 3.82687C5.94208 3.65896 6.22375 3.575 6.54875 3.575C6.91708 3.575 7.215 3.67521 7.4425 3.87562C7.67 4.07604 7.78375 4.33333 7.78375 4.6475C7.78375 4.88583 7.71333 5.11062 7.5725 5.32187C7.43167 5.53312 7.22583 5.7525 6.955 5.98C6.63 6.26167 6.38896 6.54063 6.23187 6.81687C6.07479 7.09312 5.99625 7.45875 5.99625 7.91375ZM6.5 13C5.61167 13 4.77208 12.8294 3.98125 12.4881C3.19042 12.1469 2.49979 11.681 1.90937 11.0906C1.31896 10.5002 0.853125 9.80958 0.511875 9.01875C0.170625 8.22792 0 7.38833 0 6.5C0 5.60083 0.170625 4.75583 0.511875 3.965C0.853125 3.17417 1.31896 2.48625 1.90937 1.90125C2.49979 1.31625 3.19042 0.853125 3.98125 0.511875C4.77208 0.170625 5.61167 0 6.5 0C7.39917 0 8.24417 0.170625 9.035 0.511875C9.82583 0.853125 10.5138 1.31625 11.0988 1.90125C11.6838 2.48625 12.1469 3.17417 12.4881 3.965C12.8294 4.75583 13 5.60083 13 6.5C13 7.38833 12.8294 8.22792 12.4881 9.01875C12.1469 9.80958 11.6838 10.5002 11.0988 11.0906C10.5138 11.681 9.82583 12.1469 9.035 12.4881C8.24417 12.8294 7.39917 13 6.5 13ZM6.5 12.025C8.03833 12.025 9.34375 11.486 10.4162 10.4081C11.4887 9.33021 12.025 8.0275 12.025 6.5C12.025 4.96167 11.4887 3.65625 10.4162 2.58375C9.34375 1.51125 8.03833 0.975 6.5 0.975C4.9725 0.975 3.66979 1.51125 2.59188 2.58375C1.51396 3.65625 0.975 4.96167 0.975 6.5C0.975 8.0275 1.51396 9.33021 2.59188 10.4081C3.66979 11.486 4.9725 12.025 6.5 12.025Z"
        fill={props.color}
      />
    </svg>
  );
}
export function Save(props: IconProps) {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 2.83472V11.9167C13 12.2056 12.8917 12.4583 12.675 12.675C12.4583 12.8917 12.2056 13 11.9167 13H1.08333C0.794444 13 0.541667 12.8917 0.325 12.675C0.108333 12.4583 0 12.2056 0 11.9167V1.08333C0 0.794444 0.108333 0.541667 0.325 0.325C0.541667 0.108333 0.794444 0 1.08333 0H10.1653L13 2.83472ZM11.9167 3.32222L9.67778 1.08333H1.08333V11.9167H11.9167V3.32222ZM6.5 10.7431C7.01759 10.7431 7.45995 10.5595 7.82708 10.1924C8.19421 9.82523 8.37778 9.38287 8.37778 8.86528C8.37778 8.34768 8.19421 7.90532 7.82708 7.53819C7.45995 7.17106 7.01759 6.9875 6.5 6.9875C5.98241 6.9875 5.54005 7.17106 5.17292 7.53819C4.80579 7.90532 4.62222 8.34768 4.62222 8.86528C4.62222 9.38287 4.80579 9.82523 5.17292 10.1924C5.54005 10.5595 5.98241 10.7431 6.5 10.7431ZM2.04028 4.62222H8.50417V2.04028H2.04028V4.62222ZM1.08333 3.32222V11.9167V1.08333V3.32222Z"
        fill={props.color}
      />
    </svg>
  );
}
export function Trash(props: IconProps) {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.89375 13C1.58125 13 1.31563 12.8947 1.09688 12.684C0.878125 12.4734 0.76875 12.2176 0.76875 11.9167V1.625H0V0.541667H3.525V0H8.475V0.541667H12V1.625H11.2313V11.9167C11.2313 12.2056 11.1187 12.4583 10.8937 12.675C10.6687 12.8917 10.4062 13 10.1063 13H1.89375ZM10.1063 1.625H1.89375V11.9167H10.1063V1.625ZM3.88125 10.3639H5.00625V3.15972H3.88125V10.3639ZM6.99375 10.3639H8.11875V3.15972H6.99375V10.3639Z"
        fill={props.color}
      />
    </svg>
  );
}

export function Notification(props: IconProps) {
  return (
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 16.9062L20 16.9062" stroke={props.color} strokeWidth="1.5" />
      <path
        d="M12.5 19L7.5 19C7.5 19.663 7.76339 20.2989 8.23223 20.7678C8.70107 21.2366 9.33696 21.5 10 21.5C10.663 21.5 11.2989 21.2366 11.7678 20.7678C12.2366 20.2989 12.5 19.663 12.5 19Z"
        fill={props.color}
      />
      <path
        d="M18 17L18 9C18 4.58172 14.4183 1 10 1V1C5.58172 1 2 4.58172 2 9L2 17"
        stroke={props.color}
        strokeWidth="1.5"
      />
    </svg>
  );
}

export function DownloadBig(props: IconProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.875 20C1.375 20 0.9375 19.8125 0.5625 19.4375C0.1875 19.0625 0 18.625 0 18.125V13.6562H1.875V18.125H18.125V13.6562H20V18.125C20 18.625 19.8125 19.0625 19.4375 19.4375C19.0625 19.8125 18.625 20 18.125 20H1.875ZM10 15.2187L3.96875 9.1875L5.3125 7.84375L9.0625 11.5938V0H10.9375V11.5938L14.6875 7.84375L16.0312 9.1875L10 15.2187Z"
        fill={props.color}
      />
    </svg>
  );
}

export function SearchLens(props: IconProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="9" cy="9" r="8.2" stroke={props.color} strokeWidth="1.6" />
      <rect
        x="13.6337"
        y="15.8253"
        width="2.15966"
        height="5.96378"
        transform="rotate(-45.5734 13.6337 15.8253)"
        fill={props.color}
      />
    </svg>
  );
}

export const Stamp = (props: StampProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.41823 16.4796C6.41823 16.767 6.18523 17 5.89782 17H0.520408C0.233004 17 0 16.767 0 16.4796C0 16.1923 0.233004 15.9593 0.520408 15.9593H5.89782C6.18523 15.9593 6.41823 16.1923 6.41823 16.4796ZM17 3.21051C17 4.07055 16.667 4.87713 16.0624 5.48172C15.9156 5.62849 15.65 5.79861 15.1112 6.13899C14.0973 6.77937 12.4506 7.81953 10.8979 9.28478L12.243 10.6296C12.637 11.0236 12.854 11.5492 12.854 12.1093C12.854 12.6695 12.6369 13.195 12.2429 13.589L12.1283 13.7037C12.1282 13.7037 12.1283 13.7037 12.1283 13.7037C11.3755 14.4563 10.2186 14.5648 9.34955 14.0288L8.20278 15.1754C8.10116 15.277 7.96794 15.3278 7.83482 15.3278C7.70163 15.3278 7.56847 15.277 7.46685 15.1754L1.82407 9.53351C1.72647 9.43592 1.67162 9.30358 1.67162 9.16555C1.67162 9.02751 1.72644 8.89517 1.82407 8.79759L2.97073 7.65111C2.75362 7.29938 2.63753 6.89264 2.63753 6.46734C2.63757 5.86372 2.8714 5.29748 3.29602 4.8729L3.41089 4.75811C4.22686 3.94226 5.55453 3.9422 6.37056 4.75811L7.71561 6.10295C9.18132 4.55028 10.2215 2.90392 10.8621 1.89013C11.2024 1.35146 11.3725 1.08601 11.5193 0.939266C12.7718 -0.313088 14.8098 -0.313088 16.0623 0.939266C16.667 1.54385 17 2.35047 17 3.21051ZM8.57074 13.3357L3.66399 8.42973L2.92802 9.16555L7.83478 14.0716L8.57074 13.3357ZM5.6346 5.49403C5.42956 5.28898 5.16012 5.18643 4.89076 5.18643C4.62133 5.18643 4.35197 5.28898 4.14682 5.49406L4.03195 5.60889C3.80398 5.83681 3.67842 6.14173 3.67838 6.46737C3.67838 6.79301 3.80394 7.09787 4.03195 7.32585L9.6748 12.9679C10.1482 13.4412 10.9185 13.4413 11.392 12.9679L11.5068 12.8532C11.7044 12.6556 11.8132 12.3915 11.8132 12.1093C11.8132 11.8271 11.7044 11.563 11.507 11.3655L5.6346 5.49403ZM15.9592 3.21051C15.9592 2.62844 15.7344 2.08318 15.3264 1.67519C14.4797 0.828604 13.102 0.828604 12.2553 1.67519C12.1808 1.75157 11.9477 2.12047 11.742 2.446C11.0775 3.4976 9.99694 5.20794 8.45192 6.83918L10.1616 8.54861C11.793 7.00392 13.5036 5.9235 14.5553 5.25918C14.8809 5.0535 15.25 4.82038 15.3266 4.74566C15.7344 4.3378 15.9592 3.79258 15.9592 3.21051Z"
        fill={props.color}
      />
    </svg>
  );
};

// export const KepIcon = (props: IconProps) => {
//   return (
//     <svg
//       width="17"
//       height="17"
//       viewBox="0 0 17 17"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path
//         d="M2.76825 3.22136C4.73687 1.24446 7.93533 1.23775 9.9123 3.20636L10.7807 2.3343C8.32215 -0.113963 4.3444 -0.105611 1.89614 2.35295L2.76825 3.22136ZM1.89614 2.35295C-0.552119 4.81152 -0.543766 8.78928 1.9148 11.2376L2.78325 10.3654C0.806342 8.39678 0.799626 5.19834 2.76825 3.22136L1.89614 2.35295ZM8.19149 12.9179L11.2437 15.9574L12.1122 15.0853L9.05997 12.0458L8.19149 12.9179ZM15.5396 11.6433L14.5197 10.6277L13.6513 11.4998L14.6712 12.5154L15.5396 11.6433ZM14.5197 10.6277L12.4872 8.60364L11.6188 9.47578L13.6513 11.4998L14.5197 10.6277ZM12.7407 16.4789L14.454 16.2849L14.3155 15.062L12.6022 15.256L12.7407 16.4789ZM15.8807 14.8522L16.0676 13.1381L14.844 13.0048L14.6572 14.7189L15.8807 14.8522ZM15.3033 15.8745L15.4738 15.7033L14.6017 14.8348L14.4313 15.0061L15.3033 15.8745ZM14.6572 14.7189C14.6524 14.7627 14.6329 14.8036 14.6017 14.8348L15.4738 15.7033C15.7021 15.474 15.8456 15.1739 15.8807 14.8522L14.6572 14.7189ZM14.454 16.2849C14.7755 16.2485 15.0751 16.1038 15.3033 15.8745L14.4313 15.0061C14.4002 15.0373 14.3593 15.057 14.3155 15.062L14.454 16.2849ZM14.6712 12.5154C14.8001 12.6438 14.8637 12.8239 14.844 13.0048L16.0676 13.1381C16.1278 12.5855 15.9335 12.0355 15.5396 11.6433L14.6712 12.5154ZM11.2437 15.9574C11.6375 16.3496 12.1883 16.5415 12.7407 16.4789L12.6022 15.256C12.4214 15.2765 12.2411 15.2136 12.1122 15.0853L11.2437 15.9574ZM7.61994 11.6757C5.94593 12.1093 4.09538 11.6721 2.78325 10.3654L1.9148 11.2376C3.54781 12.8637 5.85078 13.4053 7.92857 12.8671L7.61994 11.6757ZM9.9123 3.20636C11.2244 4.51307 11.6693 6.36174 11.2428 8.03755L12.4355 8.34118C12.965 6.26113 12.4137 3.96041 10.7807 2.3343L9.9123 3.20636ZM12.4872 8.60364C12.4414 8.55795 12.4042 8.46424 12.4355 8.34118L11.2428 8.03755C11.1199 8.52019 11.2217 9.08039 11.6188 9.47578L12.4872 8.60364ZM9.05997 12.0458C8.66308 11.6506 8.10238 11.5507 7.61994 11.6757L7.92857 12.8671C8.05117 12.8353 8.14544 12.8721 8.19149 12.9179L9.05997 12.0458Z"
//         fill={props.color}
//       />
//       <path
//         d="M14.5238 11.4959C14.7623 11.2538 14.7594 10.8642 14.5172 10.6257C14.2751 10.3872 13.8854 10.3902 13.647 10.6323L14.5238 11.4959ZM12.2306 12.0704C11.9921 12.3125 11.9951 12.7022 12.2372 12.9407C12.4793 13.1791 12.869 13.1762 13.1074 12.934L12.2306 12.0704ZM13.647 10.6323L12.2306 12.0704L13.1074 12.934L14.5238 11.4959L13.647 10.6323Z"
//         fill={props.color}
//       />
//       <path
//         d="M7.15116 7.58612C6.75143 7.98745 6.10206 7.98881 5.70068 7.58916L4.83223 8.46123C5.71526 9.3406 7.14393 9.3376 8.02322 8.45452L7.15116 7.58612ZM7.14812 6.13562C7.54945 6.53535 7.55081 7.1847 7.15116 7.58612L8.02322 8.45452C8.9026 7.57153 8.8996 6.14285 8.01652 5.26355L7.14812 6.13562ZM5.69764 6.13866C6.09733 5.73733 6.7467 5.73597 7.14812 6.13562L8.01652 5.26355C7.13353 4.38417 5.70486 4.38717 4.82553 5.27025L5.69764 6.13866ZM4.82553 5.27025C3.9462 6.15325 3.9492 7.58193 4.83223 8.46123L5.70068 7.58916C5.2993 7.18943 5.29794 6.54008 5.69764 6.13866L4.82553 5.27025Z"
//         fill={props.color}
//       />
//     </svg>
//   );
// }

export const SaveIcon = (props: IconProps) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4688 6.5625C12.831 6.5625 13.125 6.26916 13.125 5.90625V3.28125C13.125 2.91834 12.831 2.625 12.4688 2.625C12.1065 2.625 11.8125 2.91834 11.8125 3.28125V5.90625C11.8125 6.26916 12.1065 6.5625 12.4688 6.5625ZM19.6875 18.375C19.6875 19.0995 19.0995 19.6875 18.375 19.6875H2.625C1.9005 19.6875 1.3125 19.0995 1.3125 18.375V2.625C1.3125 1.9005 1.9005 1.3125 2.625 1.3125H3.9375V7.875C3.9375 8.5995 4.5255 9.1875 5.25 9.1875H15.75C16.4745 9.1875 17.0625 8.5995 17.0625 7.875V1.3125H18.375C19.0995 1.3125 19.6875 1.9005 19.6875 2.625V18.375ZM5.25 1.3125H15.75V7.21875C15.75 7.58166 15.456 7.875 15.0938 7.875H5.90625C5.544 7.875 5.25 7.58166 5.25 7.21875V1.3125ZM18.375 0H2.625C1.17534 0 0 1.17534 0 2.625V18.375C0 19.8247 1.17534 21 2.625 21H18.375C19.8247 21 21 19.8247 21 18.375V2.625C21 1.17534 19.8247 0 18.375 0Z"
        fill={props.color}
      />
    </svg>
  );
};

export const RefreshIcon = (props: IconProps) => {
  return (
    <svg
      width="50%"
      height="50%"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_70_612"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="22"
        height="22"
      >
        <rect
          x="0.565186"
          y="0.565216"
          width="20.8696"
          height="20.8696"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_70_612)">
        <path
          d="M13.1366 14.9661L18.3702 14.9258L18.4105 20.1594M8.88531 6.62467L3.65175 6.66498L3.61144 1.43141M18.7509 7.59903C18.1528 6.15099 17.1605 4.89976 15.8868 3.98756C14.613 3.07535 13.1092 2.53853 11.5457 2.43856C9.98219 2.33858 8.42162 2.67918 7.04208 3.42172C5.66253 4.16426 4.51913 5.27921 3.74151 6.63929M3.27065 13.9923C3.86872 15.4403 4.86101 16.6915 6.13474 17.6037C7.40849 18.516 8.91389 19.0521 10.4774 19.152C12.0409 19.252 13.6002 18.9115 14.9797 18.1689C16.3592 17.4264 17.5019 16.3116 18.2794 14.9515"
          stroke={props.color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

//   export const ErrorSignIcon = (props: IconProps) => (
//     <svg
//     width={props.value ? props.value : "20"}
//     height={props.value ? props.value : "20"}
// viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
//     <path d="M10 0C4.5 0 0 4.5 0 10C0 15.5 4.5 20 10 20C15.5 20 20 15.5 20 10C20 4.5 15.5 0 10 0ZM9 5H11V7H9V5ZM9 9H11V15H9V9Z" fill="#E73027"/>
//     </svg>

//     );

// export const WaitingSignIcon = (props: IconProps) => (
//     <svg
//       width={props.value ? props.value : "20"}
//       height={props.value ? props.value : "20"}
//       viewBox="0 0 20 20"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg">
//     <circle cx="10" cy="10" r="10" fill="#F5B100"/>
//     <path
//       d="M10 5V11.6667L12.5 14.1667"
//       stroke="white"
//       strokeLinecap="square"/>
//     </svg>
//     );

// export const SignedByAllIcon = (props: IconProps) => (
//   <svg
//   width={props.value ? props.value : "20"}
//   height={props.value ? props.value : "20"}
// viewBox="0 0 20 20"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//   <circle cx="10" cy="10" r="10" fill="#4CA92B"/>
//   <path
//     d="M5.83331 10.8333L9.16665 13.3333L15 7.5"
//     stroke="white"
//     strokeLinecap="square"
//   />
//   </svg>
//     );

// export const SignedByYouIcon = (props: IconProp) => {
//   return (
//     <svg
//     width={props.value ? props.value : "20"}
//     height={props.value ? props.value : "20"}
//     viewBox="0 0 20 20"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg">
//     <circle cx="10" cy="10" r="10" fill="#9FDF89"/>
//     <path d="M5.83331 10.8333L9.16665 13.3333L15 7.5"
//       stroke="white"
//       strokeLinecap="square"/>
//     </svg>
//     );
// }

export const ProcessSigningIcon = () => {
  return (
    <div
      style={{
        width: "16px",
        height: "16px",
        display: "flex",
        backgroundColor: "var(--disabled-bg)",
        borderRadius: "50%",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CircularProgress size={12} sx={{ color: "var(--dark-gray)" }} />
    </div>
  );
};

export const CanceledIcon = (props: IconProp) => {
  return (
    <svg
      width={props.value ? props.value : "20"}
      height={props.value ? props.value : "20"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="10" fill="#EE6D67" />
      <path
        d="M6.66669 13.3334L13.3334 6.66671"
        stroke="white"
        strokeLinecap="square"
      />
      <path
        d="M6.66669 6.66663L13.3334 13.3333"
        stroke="white"
        strokeLinecap="square"
      />
    </svg>
  );
};

export const MobEmptyDocsIcon = () => {
  return (
    <svg
      width="110"
      height="91"
      viewBox="0 0 110 91"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.2">
        <path
          d="M0 32.1877V3.78676C0 1.69513 1.69795 0 3.79304 0H30.3449C32.44 0 34.138 1.69513 34.138 3.78676V5.68042C34.138 7.77205 35.8359 9.46718 37.931 9.46718H104.31C107.452 9.46718 110 12.0102 110 15.1476V32.1883H0V32.1877Z"
          fill="black"
        />
        <path
          d="M110 15.1851V32.1882H98.819V16.4177C98.819 13.2318 96.4108 10.5532 93.2243 10.1983C91.0864 9.96008 88.2408 9.71401 84.5293 9.51648H104.295C107.446 9.51648 110 12.0545 110 15.1846V15.1851Z"
          fill="black"
        />
        <path
          d="M11.4756 29.949V20.851C11.4756 18.7646 13.1698 17.0737 15.2602 17.0737H94.7393C96.8297 17.0737 98.5239 18.7646 98.5239 20.851V29.949H11.4756Z"
          fill="#F5F5F5"
        />
        <path
          d="M104.31 26.5903H5.68988C2.54745 26.5903 0 29.1336 0 32.2709V85.2864C0 88.4237 2.54745 90.9669 5.68988 90.9669H104.31C107.453 90.9669 110 88.4237 110 85.2864V32.2709C110 29.1336 107.453 26.5903 104.31 26.5903Z"
          fill="#404852"
        />
        <path
          d="M110 32.2698V85.2864C110 88.4233 107.451 90.9669 104.306 90.9669H5.59814C40.2833 90.9669 67.5447 87.1473 82.965 84.322C91.0886 82.8332 96.9859 75.7663 96.9859 67.5269V33.3456C96.9859 30.4643 94.9751 27.9665 92.1518 27.3556C91.0137 27.1096 89.6562 26.8483 88.0611 26.5903H104.306C107.451 26.5903 110 29.1334 110 32.2703V32.2698Z"
          fill="#404852"
        />
      </g>
    </svg>
  );
};
export const EmptyDocsIcon = () => {
  return (
    <svg
      width="155"
      height="127"
      viewBox="0 0 155 127"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.2">
        <path
          d="M0.9375 44.8067V5.27133C0.9375 2.3597 3.30112 0 6.21759 0H43.179C46.0954 0 48.4591 2.3597 48.4591 5.27133V7.9074C48.4591 10.819 50.8227 13.1787 53.7392 13.1787H146.142C150.516 13.1787 154.062 16.7187 154.062 21.0861V44.8075H0.9375V44.8067Z"
          fill="black"
        />
        <path
          d="M154.062 21.139V44.8081H138.498V22.8549C138.498 18.4199 135.146 14.6913 130.71 14.1971C127.734 13.8656 123.773 13.523 118.606 13.248H146.121C150.507 13.248 154.062 16.7811 154.062 21.1383V21.139Z"
          fill="black"
        />
        <path
          d="M16.9124 41.6906V29.0257C16.9124 26.1213 19.2707 23.7676 22.1808 23.7676H132.819C135.729 23.7676 138.087 26.1213 138.087 29.0257V41.6906H16.9124Z"
          fill="#F5F5F5"
        />
        <path
          d="M146.142 37.0137H8.85806C4.48366 37.0137 0.9375 40.554 0.9375 44.9212V118.721C0.9375 123.088 4.48366 126.629 8.85806 126.629H146.142C150.516 126.629 154.062 123.088 154.062 118.721V44.9212C154.062 40.554 150.516 37.0137 146.142 37.0137Z"
          fill="#404852"
        />
        <path
          d="M154.063 44.9197V118.721C154.063 123.088 150.514 126.629 146.136 126.629H8.73035C57.0137 126.629 94.9627 121.312 116.428 117.379C127.737 115.306 135.946 105.469 135.946 93.9991V46.4173C135.946 42.4064 133.147 38.9294 129.217 38.079C127.633 37.7365 125.743 37.3727 123.522 37.0137H146.136C150.514 37.0137 154.063 40.5537 154.063 44.9205V44.9197Z"
          fill="#404852"
        />
      </g>
    </svg>
  );
};

export const LinkIcon = () => {
  return (
    <svg
      width="50%"
      height="50%"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.24663 14.7547L14.7539 7.24744M4.43192 10.0623L2.5551 11.9391C0.482039 14.0122 0.481428 17.3736 2.5545 19.4467C4.62757 21.5198 7.98968 21.5191 10.0628 19.446L11.9376 17.5695M10.0616 4.43143L11.9384 2.55462C14.0114 0.481546 17.3722 0.481918 19.4453 2.55499C21.5183 4.62805 21.5182 7.9892 19.4451 10.0622L17.5693 11.939"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ManIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.38783 14H11.6197C13.2091 14 14 13.2091 14 11.6426V2.35741C14 0.790875 13.2091 0 11.6197 0H2.38783C0.806089 0 0 0.78325 0 2.35741V11.6426C0 13.2168 0.806089 14 2.38783 14ZM7.0038 9.53612C4.30416 9.53612 2.36502 10.8365 1.54372 12.4867C1.3384 12.2814 1.22435 11.9848 1.22435 11.5818V2.41824C1.22435 1.62737 1.6502 1.22432 2.41064 1.22432H11.5969C12.3498 1.22432 12.7756 1.62737 12.7756 2.41824V11.5818C12.7756 11.9772 12.6692 12.2814 12.4638 12.4791C11.6502 10.8289 9.77183 9.53612 7.0038 9.53612ZM7.0038 8.26615C8.45624 8.28136 9.60454 7.04182 9.60454 5.41445C9.60454 3.88591 8.45624 2.6236 7.0038 2.6236C5.55132 2.6236 4.39543 3.88591 4.40302 5.41445C4.41824 7.04182 5.55132 8.24334 7.0038 8.26615Z"
        fill="black"
      />
    </svg>
  );
};
export const PubManIcon = () => {
  return (
    <svg
      width="85"
      height="72"
      viewBox="0 0 85 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1447_3117)">
        <path
          d="M70.1031 43.4198C74.4846 24.3201 62.553 5.2848 43.4533 0.903355C24.3536 -3.47809 5.31829 8.45345 0.936845 27.5532C-3.4446 46.6529 8.48694 65.6882 27.5867 70.0697C46.6864 74.4511 65.7217 62.5196 70.1031 43.4198Z"
          fill="#D1D2D4"
        />
        <path
          d="M35.5199 50.0608C43.1422 50.0608 49.3213 41.5023 49.3213 30.9449C49.3213 20.3875 43.1422 11.829 35.5199 11.829C27.8976 11.829 21.7185 20.3875 21.7185 30.9449C21.7185 41.5023 27.8976 50.0608 35.5199 50.0608Z"
          fill="white"
        />
        <path
          d="M35.3062 48.839C23.7512 48.839 13.4234 51.6058 6.55286 55.9561C12.9796 65.0346 23.5539 70.9628 35.5253 70.9628C47.4967 70.9628 57.9176 65.1168 64.3608 56.1479C57.4958 51.688 47.031 48.839 35.3117 48.839H35.3062Z"
          fill="white"
        />
        <path
          d="M37.6238 35.4814H33.416C30.505 35.4814 28.1453 37.8412 28.1453 40.7522V52.7455C28.1453 55.6564 30.505 58.0162 33.416 58.0162H37.6238C40.5347 58.0162 42.8945 55.6564 42.8945 52.7455V40.7522C42.8945 37.8412 40.5347 35.4814 37.6238 35.4814Z"
          fill="white"
        />
        <path
          d="M23.8991 32.0297C24.31 35.0924 23.6306 37.7497 22.3814 37.9633C21.1268 38.177 19.779 35.8649 19.3626 32.7967C18.9517 29.734 19.631 27.0767 20.8802 26.8631C22.1349 26.6494 23.4827 28.9615 23.8991 32.0297Z"
          fill="white"
        />
        <path
          d="M47.1461 32.0297C46.7352 35.0924 47.4146 37.7497 48.6638 37.9633C49.9185 38.177 51.2663 35.8649 51.6827 32.7967C52.0936 29.734 51.4142 27.0767 50.165 26.8631C48.9158 26.6494 47.5625 28.9615 47.1461 32.0297Z"
          fill="white"
        />
        <path
          d="M22.2006 30.1943C21.7349 27.1316 21.2747 24.0743 20.8089 21.0116C20.6391 19.8994 20.4802 18.7269 20.8857 17.6804C21.2911 16.634 22.48 15.7957 23.532 16.1902C23.1101 14.0589 25.466 12.4864 27.5206 11.7796C30.9614 10.5962 34.6487 9.99352 38.2538 10.4592C41.8589 10.9249 45.3819 12.5193 47.8145 15.2259C48.5815 16.0806 49.2445 17.0558 49.6116 18.1461C50.3184 20.2446 49.8691 22.5402 49.4143 24.7044C49.0527 26.4248 48.6911 28.1506 48.3295 29.871C48.2473 30.2655 48.1542 30.6764 47.8857 30.9777C47.4584 31.4544 46.7351 31.4873 46.0941 31.4928C39.251 31.5092 32.4078 31.5202 25.5592 31.5366C24.2716 31.5366 22.5896 31.2243 22.4197 29.9477"
          fill="white"
        />
      </g>
      <path
        d="M70.4425 71.2259C78.4611 71.2259 84.9616 64.7254 84.9616 56.7067C84.9616 48.6881 78.4611 42.1876 70.4425 42.1876C62.4238 42.1876 55.9233 48.6881 55.9233 56.7067C55.9233 64.7254 62.4238 71.2259 70.4425 71.2259Z"
        fill="#121D30"
      />
      <path
        d="M76.6314 62.1063L71.2323 56.7072L76.6314 51.3081C76.8516 51.0878 76.8516 50.7385 76.6314 50.5183C76.4111 50.2981 76.0618 50.2981 75.8416 50.5183L70.4425 55.9174L65.0434 50.5183C64.8232 50.2981 64.4739 50.2981 64.2537 50.5183C64.0334 50.7385 64.0334 51.0878 64.2537 51.3081L69.6528 56.7072L64.2537 62.1063C64.0334 62.3265 64.0334 62.6758 64.2537 62.896C64.4739 63.1162 64.8232 63.1162 65.0434 62.896L70.4425 57.4969L75.8416 62.896C76.0618 63.1162 76.4111 63.1162 76.6314 62.896C76.8516 62.6758 76.8516 62.3265 76.6314 62.1063Z"
        fill="white"
      />
      <defs>
        <clipPath id="clip0_1447_3117">
          <rect
            width="70.9683"
            height="70.9683"
            fill="white"
            transform="translate(0.0384521)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const EmptyDocForPdfViewer = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 407 300"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M182.47 77.33H16.27V199.93H182.47V77.33Z" fill="#F5F9FF" />
      <path d="M182.47 77.33H16.27V92.62H182.47V77.33Z" fill="#D0DBF7" />
      <path
        d="M29.61 85.33C29.61 87.26 28.04 88.83 26.11 88.83C24.18 88.83 22.61 87.26 22.61 85.33C22.61 83.4 24.18 81.83 26.11 81.83C28.04 81.83 29.61 83.4 29.61 85.33Z"
        fill="#F2F2F2"
      />
      <path
        d="M41.39 85.33C41.39 87.26 39.82 88.83 37.89 88.83C35.96 88.83 34.39 87.26 34.39 85.33C34.39 83.4 35.96 81.83 37.89 81.83C39.82 81.83 41.39 83.4 41.39 85.33Z"
        fill="#F2F2F2"
      />
      <path
        d="M53.18 85.33C53.18 87.26 51.61 88.83 49.68 88.83C47.75 88.83 46.18 87.26 46.18 85.33C46.18 83.4 47.75 81.83 49.68 81.83C51.61 81.83 53.18 83.4 53.18 85.33Z"
        fill="#F2F2F2"
      />
      <path
        d="M127.74 125.97L119.39 117.61L99.37 137.63L79.35 117.61L70.99 125.97L91.01 145.99L70.99 166L79.35 174.36L99.37 154.34L119.39 174.36L127.74 166L107.72 145.99L127.74 125.97Z"
        fill="#E3EBFC"
      />
      <path d="M386.49 0H220.29V122.6H386.49V0Z" fill="#F5F9FF" />
      <path d="M386.49 0H220.29V15.29H386.49V0Z" fill="#D0DBF7" />
      <path
        d="M233.63 8C233.63 9.93 232.06 11.5 230.13 11.5C228.2 11.5 226.63 9.93 226.63 8C226.63 6.07 228.2 4.5 230.13 4.5C232.06 4.5 233.63 6.07 233.63 8Z"
        fill="#F2F2F2"
      />
      <path
        d="M245.42 8C245.42 9.93 243.85 11.5 241.92 11.5C239.99 11.5 238.42 9.93 238.42 8C238.42 6.07 239.99 4.5 241.92 4.5C243.85 4.5 245.42 6.07 245.42 8Z"
        fill="#F2F2F2"
      />
      <path
        d="M257.2 8C257.2 9.93 255.63 11.5 253.7 11.5C251.77 11.5 250.2 9.93 250.2 8C250.2 6.07 251.77 4.5 253.7 4.5C255.63 4.5 257.2 6.07 257.2 8Z"
        fill="#F2F2F2"
      />
      <path
        d="M331.77 48.64L323.41 40.29L303.39 60.3L283.37 40.29L275.02 48.64L295.04 68.66L275.02 88.68L283.37 97.03L303.39 77.02L323.41 97.03L331.77 88.68L311.75 68.66L331.77 48.64Z"
        fill="#E3EBFC"
      />
      <path
        d="M203.17 299.1C315.378 299.1 406.34 291.238 406.34 281.54C406.34 271.842 315.378 263.98 203.17 263.98C90.9623 263.98 0 271.842 0 281.54C0 291.238 90.9623 299.1 203.17 299.1Z"
        fill="#EDF0FC"
      />
      <path
        d="M301.62 267.79C300.81 273.14 295.44 277.52 289.67 277.52H119.18C113.42 277.52 107.98 273.15 107.1 267.81L78.87 96.61C77.99 91.27 81.98 86.9 87.75 86.9H318.49C324.25 86.9 328.31 91.28 327.5 96.63L301.63 267.79H301.62Z"
        fill="#DFECFF"
      />
      <path
        d="M258.84 29.69H115.27V231.94H290.83V62.16L258.84 29.69Z"
        fill="#C2CEF2"
      />
      <path d="M258.84 29.69L291.07 61.92H258.84V29.69Z" fill="#DEE6F1" />
      <path
        d="M251.79 93.65L237.47 79.33L203.17 113.63L168.87 79.33L154.56 93.65L188.85 127.94L154.56 162.24L168.87 176.56L203.17 142.26L237.47 176.56L251.79 162.24L217.49 127.94L251.79 93.65Z"
        fill="#AFC2E8"
      />
      <path
        d="M219.83 145.64C215.3 145.64 210.51 142.11 209.17 137.78L202.59 116.45C201.26 112.12 196.46 108.58 191.93 108.58H74.98C70.45 108.58 67.4 112.23 68.19 116.68L96.74 277.54C97.53 282 101.88 285.64 106.41 285.64H309C313.53 285.64 317.81 281.98 318.52 277.51L338.16 153.58C338.87 149.11 335.74 145.46 331.22 145.46L219.83 145.62V145.64Z"
        fill="#F7F8FA"
      />
      <path
        opacity="0.1"
        d="M331.22 145.48L318.55 145.5C318.83 148.42 318.98 151.36 318.98 154.33C318.98 220.76 247.88 274.62 160.17 274.62C136.67 274.62 114.37 270.75 94.31 263.82L96.75 277.56C97.54 282.02 101.89 285.66 106.42 285.66H309.01C313.54 285.66 317.82 282 318.53 277.53L338.17 153.6C338.88 149.13 335.75 145.48 331.23 145.48H331.22Z"
        fill="#0046A0"
      />
      <g opacity="0.3">
        <path
          d="M87.86 132.46C88.46 136.5 89.06 140.54 89.67 144.57C91.1 154.18 92.54 163.79 93.97 173.4C95.71 185.1 97.46 196.8 99.21 208.5C100.71 218.55 102.21 228.59 103.7 238.64C104.2 241.98 104.7 245.32 105.19 248.65C105.42 250.22 105.56 251.84 105.9 253.39C105.91 253.46 105.92 253.53 105.93 253.59C106.14 254.97 107.87 255.72 109.09 255.39C110.56 254.99 111.09 253.61 110.89 252.23C110.29 248.19 109.69 244.15 109.08 240.12C107.65 230.51 106.21 220.9 104.78 211.29C103.03 199.59 101.29 187.89 99.54 176.19C98.04 166.14 96.54 156.1 95.05 146.05C94.55 142.71 94.05 139.37 93.56 136.04C93.33 134.47 93.19 132.85 92.85 131.3C92.84 131.23 92.83 131.16 92.82 131.1C92.61 129.72 90.88 128.97 89.66 129.3C88.19 129.7 87.66 131.08 87.86 132.46Z"
          fill="white"
        />
      </g>
      <path
        d="M370.18 43.4C354.37 43.4 341.56 56.22 341.56 72.02C341.56 79.09 344.12 85.55 348.37 90.54L347.17 105.28L360.85 99.08C363.78 100.09 366.92 100.65 370.19 100.65C386 100.65 398.81 87.83 398.81 72.03C398.81 56.23 385.99 43.41 370.19 43.41L370.18 43.4Z"
        fill="#D0DBF7"
      />
      <path
        d="M368.2 86.68C367.68 86.16 367.42 85.51 367.42 84.74C367.42 83.97 367.68 83.32 368.2 82.8C368.72 82.28 369.37 82.01 370.14 82.01C370.91 82.01 371.56 82.27 372.1 82.8C372.64 83.32 372.91 83.97 372.91 84.74C372.91 85.51 372.64 86.16 372.1 86.68C371.56 87.2 370.91 87.47 370.14 87.47C369.37 87.47 368.72 87.21 368.2 86.68ZM366.58 54.49H373.79L372.45 77.54H367.92L366.58 54.49Z"
        fill="#F2F2F2"
      />
      <path
        opacity="0.1"
        d="M354.5 87.19C351.39 87.19 348.36 86.92 345.44 86.4C346.3 87.87 347.28 89.25 348.37 90.54L347.17 105.28L360.85 99.08C363.78 100.09 366.92 100.65 370.19 100.65C386 100.65 398.81 87.83 398.81 72.03C398.81 68.2 398.05 64.55 396.69 61.21C390.96 76.29 374.25 87.2 354.51 87.2L354.5 87.19Z"
        fill="#0046A0"
      />
      <path
        d="M76.92 35.66V8.52C76.92 5.26 74.25 2.59 70.99 2.59H21.52C18.26 2.59 15.59 5.26 15.59 8.52V42.72C15.59 45.98 18.26 48.65 21.52 48.65H91.19L76.92 35.66Z"
        fill="#D0DBF7"
      />
      <path
        opacity="0.1"
        d="M76.92 35.66V8.52C76.92 5.26 74.25 2.59 70.99 2.59H65.92C66.8 5.81 67.27 9.16 67.27 12.59C67.27 27.01 59.08 39.92 46.16 48.65H91.19L76.92 35.66Z"
        fill="#0046A0"
      />
      <path
        d="M247.87 187.67C232.01 203.53 232.01 229.26 247.87 245.12C263.73 260.98 289.46 260.98 305.32 245.12C321.18 229.26 321.18 203.53 305.32 187.67C289.46 171.81 263.73 171.81 247.87 187.67ZM300.66 240.46C287.37 253.75 265.82 253.75 252.52 240.46C239.23 227.17 239.23 205.62 252.52 192.32C265.81 179.03 287.36 179.03 300.66 192.32C313.95 205.61 313.95 227.16 300.66 240.46Z"
        fill="#C2CEF2"
      />
      <path
        opacity="0.3"
        d="M276.59 250.44C295.39 250.44 310.63 235.2 310.63 216.4C310.63 197.6 295.39 182.36 276.59 182.36C257.79 182.36 242.55 197.6 242.55 216.4C242.55 235.2 257.79 250.44 276.59 250.44Z"
        fill="white"
      />
      <path
        d="M304.223 238.929L299.132 244.021L345.193 290.082L350.284 284.99L304.223 238.929Z"
        fill="#AFC2E8"
      />
      <path
        d="M304.219 238.942L299.128 244.033L316.091 260.996L321.182 255.905L304.219 238.942Z"
        fill="#C2CEF2"
      />
      <path
        d="M256.77 202.4C258.06 198.67 260.89 195.66 264.3 193.57C267.73 191.49 271.79 190.38 275.86 190.38C279.93 190.37 284 191.48 287.43 193.56C290.84 195.65 293.67 198.67 294.95 202.4C291.23 201.14 288.08 200.15 284.95 199.54C281.85 198.91 278.86 198.62 275.86 198.61C272.86 198.61 269.86 198.9 266.76 199.53C263.63 200.14 260.48 201.14 256.77 202.4Z"
        fill="white"
      />
    </svg>
  );
};

export const Tariffs = (props: IconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_64_137"
        // style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_64_137)">
        <path
          d="M3 13.8C3 10.4059 3 8.70884 4.05441 7.65442C5.10883 6.60001 6.80588 6.60001 10.2 6.60001H13.8C17.1941 6.60001 18.8912 6.60001 19.9456 7.65442C21 8.70884 21 10.4059 21 13.8C21 17.1941 21 18.8912 19.9456 19.9456C18.8912 21 17.1941 21 13.8 21H10.2C6.80588 21 5.10883 21 4.05441 19.9456C3 18.8912 3 17.1941 3 13.8Z"
          stroke={props.color}
        />
        <path
          d="M15.6 6.6C15.6 4.90294 15.6 4.05441 15.0728 3.52721C14.5456 3 13.6971 3 12 3C10.303 3 9.45444 3 8.92724 3.52721C8.40002 4.05441 8.40002 4.90294 8.40002 6.6"
          stroke={props.color}
        />
        <path
          d="M12 16.8C12.9941 16.8 13.8 16.1284 13.8 15.3C13.8 14.4716 12.9941 13.8 12 13.8C11.0058 13.8 10.2 13.1284 10.2 12.3C10.2 11.4716 11.0058 10.8 12 10.8M12 16.8C11.0058 16.8 10.2 16.1284 10.2 15.3M12 16.8V17.4M12 10.8V10.2M12 10.8C12.9941 10.8 13.8 11.4716 13.8 12.3"
          stroke={props.color}
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
};

export const BoxPerson = () => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0073 3.79559H2.40146C1.62746 3.79559 1 4.42305 1 5.19706V13.5985C1 14.3725 1.62746 15 2.40146 15H15.0073C15.7813 15 16.4088 14.3725 16.4088 13.5985V5.19706C16.4088 4.42305 15.7813 3.79559 15.0073 3.79559Z"
        stroke="#1860D9"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M10.1062 8.73373H13.6061C13.977 8.73473 14.3443 8.66194 14.6868 8.5196C15.0292 8.37725 15.3399 8.1682 15.6008 7.90461C15.8616 7.64101 16.0674 7.32816 16.2062 6.98425C16.345 6.64034 16.4139 6.27227 16.4091 5.90145V5.1677C16.4091 4.79601 16.2614 4.43954 15.9986 4.17671C15.7358 3.91389 15.3793 3.76624 15.0076 3.76624H2.40177C2.21523 3.76619 2.03056 3.80339 1.85859 3.87565C1.68661 3.94791 1.53079 4.05377 1.40026 4.18704C1.26973 4.3203 1.16712 4.47828 1.09844 4.65171C1.02976 4.82515 0.996401 5.01055 1.00031 5.19705V5.9308C0.999339 6.29916 1.07118 6.66407 1.2117 7.00458C1.35221 7.34508 1.55864 7.65446 1.81911 7.91493C2.07958 8.1754 2.38895 8.38182 2.72946 8.52234C3.06996 8.66286 3.43488 8.73469 3.80323 8.73373H10.1062Z"
        stroke="#1860D9"
        strokeMiterlimit="10"
      />
      <path
        d="M8.70459 7.99994V9.4014"
        stroke="#1860D9"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M11.5077 3.79559H5.90186L6.60626 1H10.8033L11.5077 3.79559Z"
        stroke="#1860D9"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  );
};

// export const Contracts = (props: IconProps) => {
//   return (
//     <svg width="24" height="24" viewBox="0 0 24 24"
//       fill="none" xmlns="http://www.w3.org/2000/svg">
//       <mask id="mask0_65_167"
//       // style="mask-type:alpha"
//        maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
//       <rect width="24" height="24" fill="#D9D9D9"/>
//       </mask>
//       <g mask="url(#mask0_65_167)">
//       <rect x="3.5" y="4.42302" width="17.2686" height="17.2686" rx="3.5" stroke={props.color}/>
//       <path d="M10.2113 6.80754V2" stroke={props.color} strokeLinecap="round"/>
//       <path d="M14.0573 6.80754V2" stroke={props.color} strokeLinecap="round"/>
//       <circle cx="12.1343" cy="14.0189" r="1.90377" stroke={props.color}/>
//       <path d="M17.8776 21.3738C17.5734 20.6358 17.1269 19.9649 16.5635 19.3995C16.0001 18.8341 15.3308 18.3852 14.5939 18.0784C13.8571 17.7716 13.0669 17.613 12.2687 17.6116C11.4705 17.6101 10.6799 17.7659 9.94189 18.0701C9.2039 18.3742 8.53304 18.8207 7.96762 19.3841C7.40219 19.9475 6.95328 20.6168 6.6465 21.3537"
//       stroke={props.color}/>
//       </g>
//     </svg>
//   );
// }

export const ZoomIcon = () => {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_73_1018"
        // style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_73_1018)">
        <path
          d="M8.4 19.4H3.9C3.40294 19.4 3 18.9971 3 18.5V5.9C3 5.40294 3.40294 5 3.9 5H20.1C20.5971 5 21 5.40294 21 5.9V8.6"
          stroke="#1860D9"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.1 12.2H12.9C12.4029 12.2 12 12.6029 12 13.1V18.5C12 18.997 12.4029 19.4 12.9 19.4H20.1C20.5971 19.4 21 18.997 21 18.5V13.1C21 12.6029 20.5971 12.2 20.1 12.2Z"
          stroke="#1860D9"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

interface IconProps {
  size?: number | string;
  width?: number | string;
  height?: number | string;
  color?: string;
  circleColor?: string;
  className?: string;
}

export const DoneIcon: React.FC<IconProps> = ({
  size = 30,
  width,
  height,
  color = "#1860D9",
  circleColor = "#E4ECFF",
  className,
}) => {
  const w = width || size;
  const h = height || size;

  return (
    <svg
      width={w}
      height={h}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ minWidth: w, flexShrink: 0 }}
    >
      <circle cx="15" cy="15" r="15" fill={circleColor} />
      <path
        d="M7 17.5295L10.043 19.8117C10.4464 20.1143 11.0167 20.0451 11.3361 19.6548L19.2355 10"
        stroke={color}
        strokeLinecap="round"
      />
      <path
        d="M10.2627 17.5295L13.3056 19.8117C13.7091 20.1143 14.2794 20.0451 14.5988 19.6548L22.4982 10"
        stroke={color}
        strokeLinecap="round"
      />
    </svg>
  );
};

export const DocumentsIcon: React.FC<IconProps> = ({
  size = 20,
  width,
  height,
  color = "var(--black) ",
  className,
}) => {
  const w = width || size;
  const h = height || size;

  return (
    <svg
      width={w}
      height={h}
      viewBox="0 -960 960 960"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ minWidth: w, flexShrink: 0, stroke: color, strokeWidth: 1 }}
    >
      <path d="M373.77-429.23h168.85V-460H373.77v30.77Zm0-106.15h312.69v-30.77H373.77v30.77Zm0-106.16h312.69v-30.77H373.77v30.77Zm-76.85 380q-23.05 0-39.22-16.16-16.16-16.17-16.16-39.22v-467.7q0-23.05 16.16-39.22Q273.87-840 296.92-840h467.7q23.05 0 39.22 16.16Q820-807.67 820-784.62v467.7q0 23.05-16.16 39.22-16.17 16.16-39.22 16.16h-467.7Zm0-30.77h467.7q9.23 0 16.92-7.69 7.69-7.69 7.69-16.92v-467.7q0-9.23-7.69-16.92-7.69-7.69-16.92-7.69h-467.7q-9.23 0-16.92 7.69-7.69 7.69-7.69 16.92v467.7q0 9.23 7.69 16.92 7.69 7.69 16.92 7.69ZM195.38-160q-23.05 0-39.22-16.16Q140-192.33 140-215.38v-498.47h30.77v498.47q0 9.23 7.69 16.92 7.69 7.69 16.92 7.69h498.47V-160H195.38Zm76.93-649.23v516.92-516.92Z" />
    </svg>
  );
};

export const ArchiveDownloadIcon: React.FC<IconProps> = ({
  // size = 34,
  width = "80%",
  height = "80%",
  color = "currentColor",
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 -960 960 960"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{
        flexShrink: 0,
        stroke: color,
      }}
    >
      {/* 200 weight <path d="m480-536.92-132.31 132.3L376-376.31l84-84v188h40v-188l84 84 28.31-28.31L480-536.92ZM200-647.69v423.07q0 10.77 6.92 17.7 6.93 6.92 17.7 6.92h510.76q10.77 0 17.7-6.92 6.92-6.93 6.92-17.7v-423.07H200ZM230.77-160q-26.85 0-48.81-21.96T160-230.77v-429.77q0-11.69 3.73-22t11.19-19l62.31-74.84q8.69-11.7 21.73-17.66Q272-800 286.92-800h384.62q14.92 0 28.34 5.96 13.43 5.96 22.12 17.66L785.08-700q7.46 8.69 11.19 19.38 3.73 10.7 3.73 22.39v427.46q0 26.85-21.96 48.81T729.23-160H230.77Zm-15.54-527.69H744l-53.23-63.85q-3.85-3.84-8.85-6.15-5-2.31-10.38-2.31H287.69q-5.38 0-10.38 2.31-5 2.31-8.85 6.15l-53.23 63.85ZM480-423.85Z"/> */}
      <path d="M480-530 356-406l20 20 90-90v194h28v-194l90 90 20-20-124-124ZM200-650v418q0 14 9 23t23 9h496q14 0 23-9t9-23v-418H200Zm40 478q-25 0-46.5-21.5T172-240v-409q0-11 3.5-20.5T186-687l66-79q8-11 20-16.5t26-5.5h362q14 0 26.5 5.5T707-766l67 81q7 8 10.5 18t3.5 21v406q0 25-21.5 46.5T720-172H240Zm-25-506h529l-59-71q-5-5-11.5-8t-13.5-3H299q-7 0-13.5 3t-11.5 8l-59 71Zm265 253Z" />
    </svg>
  );
};

export const ArchiveUploadIcon: React.FC<IconProps> = ({
  width = "80%",
  height = "80%",
  color = "currentColor",
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 -960 960 960"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{
        flexShrink: 0,
        stroke: color,
      }}
    >
      <path d="m480-281.54 131.18-131.18L587.9-436l-90.98 90.97v-198.2h-33.84v198.2L372.1-436l-23.28 23.28L480-281.54ZM193.85-658.05v439.59q0 10.77 6.92 17.69 6.92 6.92 17.69 6.92h523.08q10.77 0 17.69-6.92 6.92-6.92 6.92-17.69v-439.59h-572.3ZM224.61-160q-23.91 0-44.26-20.35Q160-200.7 160-224.61v-439.01q0-9.97 3.24-19.35 3.25-9.38 9.73-17.29l63.13-77.92q7.72-10.2 19.71-16.01 12-5.81 25.78-5.81h395.13q13.78 0 26.16 5.81t20.09 16.01l64.06 79.46q6.48 7.91 9.73 17.67 3.24 9.77 3.24 19.74v436.7q0 23.91-20.35 44.26Q759.3-160 735.39-160H224.61Zm-15.38-531.9h540.1l-53.95-65.79q-3.85-3.85-8.85-6.16-5-2.3-10.38-2.3H282.51q-5.38 0-10.64 2.3-5.25 2.31-8.59 6.16l-54.05 65.79ZM480-425.95Z" />
    </svg>
  );
};

export const CheckIcon: React.FC<IconProps> = ({
  width = "20",
  height = "100%",
  color = "currentColor",
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 -960 960 960"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{
        flexShrink: 0,
        stroke: color,
      }}
    >
      <path d="M224.62-160q-26.85 0-45.74-18.88Q160-197.77 160-224.62v-510.76q0-26.85 18.88-45.74Q197.77-800 224.62-800h510.76q10.31 0 19.62 3.04t17.08 9.11l-33.23 33.23q-2.31-2.3-5.77-3.84Q729.62-760 725-760H224.62q-10.77 0-17.7 6.92-6.92 6.93-6.92 17.7v510.76q0 10.77 6.92 17.7 6.93 6.92 17.7 6.92h510.76q10.77 0 17.7-6.92 6.92-6.93 6.92-17.7v-269.84l40-40v309.84q0 26.85-18.88 45.74Q762.23-160 735.38-160H224.62ZM461-308.46 278.85-490.62l28.3-28.3 154.62 154.61 351.61-351.61 27.77 27.3L461-308.46Z" />
    </svg>
  );
};

export const SettingsIcon: React.FC<IconProps> = ({
  width = "20",
  height = "100%",
  color = "currentColor",
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 -960 960 960"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{
        flexShrink: 0,
        stroke: color,
      }}
    >
      <path d="m405.38-120-14.46-115.69q-19.15-5.77-41.42-18.16-22.27-12.38-37.88-26.53L204.92-235l-74.61-130 92.23-69.54q-1.77-10.84-2.92-22.34-1.16-11.5-1.16-22.35 0-10.08 1.16-21.19 1.15-11.12 2.92-25.04L130.31-595l74.61-128.46 105.93 44.61q17.92-14.92 38.77-26.92 20.84-12 40.53-18.54L405.38-840h149.24l14.46 116.46q23 8.08 40.65 18.54 17.65 10.46 36.35 26.15l109-44.61L829.69-595l-95.31 71.85q3.31 12.38 3.7 22.73.38 10.34.38 20.42 0 9.31-.77 19.65-.77 10.35-3.54 25.04L827.92-365l-74.61 130-107.23-46.15q-18.7 15.69-37.62 26.92-18.92 11.23-39.38 17.77L554.62-120H405.38ZM440-160h78.23L533-268.31q30.23-8 54.42-21.96 24.2-13.96 49.27-38.27L736.46-286l39.77-68-87.54-65.77q5-17.08 6.62-31.42 1.61-14.35 1.61-28.81 0-15.23-1.61-28.81-1.62-13.57-6.62-29.88L777.77-606 738-674l-102.08 42.77q-18.15-19.92-47.73-37.35-29.57-17.42-55.96-23.11L520-800h-79.77l-12.46 107.54q-30.23 6.46-55.58 20.81-25.34 14.34-50.42 39.42L222-674l-39.77 68L269-541.23q-5 13.46-7 29.23t-2 32.77q0 15.23 2 30.23t6.23 29.23l-86 65.77L222-286l99-42q23.54 23.77 48.88 38.12 25.35 14.34 57.12 22.34L440-160Zm38.92-220q41.85 0 70.93-29.08 29.07-29.07 29.07-70.92t-29.07-70.92Q520.77-580 478.92-580q-42.07 0-71.04 29.08-28.96 29.07-28.96 70.92t28.96 70.92Q436.85-380 478.92-380ZM480-480Z" />
    </svg>
  );
};

<svg
  xmlns="http://www.w3.org/2000/svg"
  height="24px"
  viewBox="0 -960 960 960"
  width="24px"
  fill="#1f1f1f"
>
  <path />
</svg>;

export const Edit: React.FC<IconProps> = ({
  width = "20",
  height = "20",
  color = "currentColor",
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 -960 960 960"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{
        flexShrink: 0,
        // display: 'inline-block' — часто допомагає з вирівнюванням
      }}
    >
      <path
        d="M80 0v-80h800V0H80Zm160-286.92h42.92l352-351.77-21.3-22.08-21.85-21.08-351.77 352v42.93Zm-40 40v-100l448.77-448.54q6.38-6.39 13.96-9.31 7.58-2.92 15.44-2.92 7.86 0 15.23 2.92t13.98 9.54l41.16 41.38q6.61 6.39 9.42 13.82 2.81 7.44 2.81 15.37 0 7.43-2.93 15.13-2.92 7.7-9.3 14.07L300-246.92H200Zm520.77-477.85-42.92-42.92 42.92 42.92Zm-85.85 86.08-21.3-22.08-21.85-21.08 43.15 43.16Z"
        fill={color} // Було props.color, стало color
      />
    </svg>
  );
};

export const Remove: React.FC<IconProps> = ({
  size,
  width = size ?? "20",
  height = size ?? "20",
  color = "currentColor",
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 -960 960 960"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{
        flexShrink: 0,
      }}
    >
      <path
        d="M304.62-160q-26.85 0-45.74-18.88Q240-197.77 240-224.62V-720h-40v-40h160v-30.77h240V-760h160v40h-40v495.38q0 27.62-18.5 46.12Q683-160 655.38-160H304.62ZM680-720H280v495.38q0 10.77 6.92 17.7 6.93 6.92 17.7 6.92h350.76q9.24 0 16.93-7.69 7.69-7.69 7.69-16.93V-720ZM392.31-280h40v-360h-40v360Zm135.38 0h40v-360h-40v360ZM280-720v520-520Z"
        fill={color}
      />
    </svg>
  );
};

export const Clean: React.FC<IconProps> = ({
  width = "20",
  height = "20",
  color = "currentColor",
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 -960 960 960"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{
        flexShrink: 0,
      }}
    >
      <path
        d="M595.38-260v-40h120v40h-120Zm0-320v-40h240v40h-240Zm0 160v-40h200v40h-200ZM164.62-640h-40v-40h149.23v-35.39h101.53V-680h149.24v40h-40v335.38q0 27.62-18.5 46.12Q447.62-240 420-240H229.23q-27.61 0-46.11-18.5t-18.5-46.12V-640Zm40 0v335.38q0 9.24 7.69 16.93Q220-280 229.23-280H420q9.23 0 16.92-7.69 7.7-7.69 7.7-16.93V-640h-240Zm0 0v360-360Z"
        fill={color}
      />
    </svg>
  );
};

export const DiiaIcon: React.FC<IconProps> = ({
  width = "24",
  height = "24",
  color = "black ",
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{
        flexShrink: 0,
        border: "1px solid white",
        borderRadius: "30%",
      }}
    >
      <path
        d="M512 1024C736.36 1024 861.082 1024 942.541 942.541C1024 861.082 1024 736.434 1024 512C1024 287.566 1024 162.918 942.541 81.4588C861.082 0 736.36 0 512 0C287.64 0 162.918 0 81.4588 81.4588C0 162.918 0 287.64 0 512C0 736.36 0 861.082 81.4588 942.541C162.918 1024 287.64 1024 512 1024Z"
        fill={color}
      />
      <path
        d="M704.294 410.767C665.617 410.767 636.91 440.624 636.91 477.464C636.91 507.544 658.06 531.014 684.835 537.959L629.947 622.036H681.214L727.876 543.789H762.803V622.036H805.603V410.767H704.294ZM710.181 508.046C692.578 508.046 681.678 494.231 681.678 478.485C681.678 462.739 691.668 447.736 710.181 447.736H762.859V508.046H710.181Z"
        fill="white"
      />
      <path
        d="M469.904 410.767L455.699 449.871L513.985 449.537L479.467 576.135C469.625 613.049 508.099 640.938 540.928 619.232L615.59 568.578L593.606 536.269L519.036 587.926L569.3 410.767H469.904Z"
        fill="white"
      />
      <path
        d="M550.289 383.601C566.645 383.601 579.905 371.655 579.905 356.919C579.905 342.183 566.645 330.236 550.289 330.236C533.932 330.236 520.672 342.183 520.672 356.919C520.672 371.655 533.932 383.601 550.289 383.601Z"
        fill="white"
      />
      <path
        d="M399.216 583.039V361.669H234.981V479.819C234.981 535.412 218.882 569.782 209.394 582.946H189.934V679.501H231.583V622.422H387.296V679.594H428.926V583.039H399.216ZM276.388 477.386V400.941H356.51V582.909H253.085C262.462 567.572 276.388 528.542 276.388 477.386Z"
        fill="white"
      />
    </svg>
  );
};
